import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc';
import { vuexArgoCreateRouterGuard } from '../store/module/session';

// configure vue to use router.
Vue.use(VueRouter);
// // define the routes with component lazy loading.
const routes = [
  { path: '/search', name: 'Search', meta: { title: 'Dashboard', roles: [ 'wtr.admin' ] }, component: ()=> import('../views/Search.vue'), beforeEnter: vuexArgoCreateRouterGuard(store, 'argoStore') }, 
  { path: '/calendar', name: 'MyTime', meta: { title: 'Il mio tempo', roles: [ 'wtr.admin', 'wtr.reg' ] }, component: ()=> import('../views/MyTime.vue'), beforeEnter: vuexArgoCreateRouterGuard(store, 'argoStore') },
  { path: '/settings', name: 'Settings', meta: { title: 'Impostazioni', roles: [ 'wtr.admin' ] }, component: ()=> import('../views/Settings.vue'), beforeEnter: vuexArgoCreateRouterGuard(store, 'argoStore') },
  { path: '/error/:type', name: 'ErrorPage', component: ()=> import('../views/ErrorPage.vue') },
];
// create new vue router with defined routes.
const router = new VueRouter({ /* mode: 'history', */ routes: routes });
// the router middleware will ensure that routes that require authentication are not rendered.
router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'));
// export router module.
export default router;
